import { useEffect } from 'react';

import { useParams, useSelector } from 'third-party';

import { useApp } from 'modules/app';

import { appSelectors } from 'selectors';

export const useTenant = () => {
  const { tenantId } = useParams();
  const userId = useSelector(appSelectors.userId);
  const selectedTenant = useSelector(appSelectors.selectedTenant);
  const { selectTenant } = useApp();

  useEffect(() => {
    if (userId && selectedTenant?.tenant.id != tenantId) {
      selectTenant(tenantId);
    }
  }, [tenantId, userId, selectTenant, selectedTenant?.tenant.id]);
};
